export default function Demo() {
  return (
    <>
      <section className="demo px-5 py-10 xl:py-20">
        <p className="text-white text-center max-w-xl mx-auto md:max-w-4xl">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam
          ratione deleniti repellendus quaerat rem ipsa, enim inventore
          consequuntur esse officia unde impedit harum voluptatibus modi autem
          at sequi omnis repellat!
        </p>
        <button className="btn-light btn-light-large block mx-auto mt-5 lg:mt-10">
          Book a demo
        </button>
      </section>
    </>
  )
}
